<template>
  <div class="home-page">
      <Toolbar :icon="'searchCheck'" :title="'History'"/>
      <ProductTable :columns="columns" :rows="history"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Toolbar from "@/components/Toolbar";
import ProductTable from "@/components/ProductTable/ProductTable";

export default {
  name: "SyncHistory",
  computed: {
    ...mapGetters(["isAuthenticated", "tags"]),
    tag() {
      return this.$route.params.tag;
    }
  },
  data: function() {
      return {
          columns: [
              {key: 'GTIN', style: {width: '20%', minWidth: '100px'}},
              {key: 'productDescription', style: {width: '30%', minWidth: '200px'}},
              {key: 'brandOwner',  style: {width: '20%', minWidth: '100px'}},
              {key: 'date', style: {width: '10%', minWidth: '100px'}},
              {key: 'status', style: {width: '20%', minWidth: '100px'}}
          ],
          history: [
            {GTIN: '123456', productDescription: 'test', brandOwner: 'PNP', date: '2021-01-01', status: 'registered'},
            {GTIN: '5342562', productDescription: 'test 2324', brandOwner: 'PNP', date: '2021-01-01', status: 'registered'},
            {GTIN: '12125', productDescription: 'atope mil', brandOwner: 'PNP', date: '2021-01-01', status: 'Pending'}
          ]
      }
  },
  components: {
      Toolbar,
      ProductTable
  }
};
</script>
